(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avirell-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.avirellScrollRevealV2) return;
  window.avirellScrollRevealV2 = true;
  const states = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = scope => {
    const roots = [...scope.querySelectorAll('[data-av-scroll-root]')];
    if (scope.matches && scope.matches('[data-av-scroll-root]')) roots.unshift(scope);
    roots.forEach(root => {
      if (states.has(root) || !('IntersectionObserver' in window)) return;
      const animations = new Map();
      const entered = new Set();
      let selected = false;
      const observer = new IntersectionObserver(entries => {
        let stagger = 0;
        entries.forEach(entry => {
          const target = entry.target;
          if (!entry.isIntersecting) {
            entered.delete(target);
            const previous = animations.get(target);
            if (previous) { previous.cancel(); animations.delete(target); }
            return;
          }
          if (entered.has(target)) return;
          entered.add(target);
          if (reduced.matches || selected || !target.animate) return;
          const animation = target.animate([
            { opacity: 0, transform: 'translateY(10px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], {
            duration: 1250,
            delay: Math.min(stagger++ * 90, 180),
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'backwards'
          });
          animations.set(target, animation);
          const release = () => {
            if (animations.get(target) === animation) animations.delete(target);
          };
          animation.onfinish = release;
          animation.oncancel = release;
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll(root.dataset.avScrollSelector).forEach(target => observer.observe(target));
      states.set(root, { observer, animations, select: () => { selected = true; } });
    });
  };
  const finish = scope => {
    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) {
        state.animations.forEach(animation => animation.finish());
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  const select = event => {
    const scope = event.target.closest('[data-av-scroll-root]') || event.target;
    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) state.select();
    });
    finish(scope);
  };
  document.addEventListener('shopify:section:select', select);
  document.addEventListener('shopify:block:select', select);
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, root) => {
      if (event.target.contains(root)) {
        state.observer.disconnect();
        state.animations.forEach(animation => animation.cancel());
        states.delete(root);
      }
    });
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) finish(document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avirell-categories"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.avirellCategoryAnimationInstalled) return;
  window.avirellCategoryAnimationInstalled = true;

  const states = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initialize = scope => {
    const roots = [...scope.querySelectorAll('[data-av-category-animation]')];

    if (scope.matches && scope.matches('[data-av-category-animation]')) {
      roots.unshift(scope);
    }

    roots.forEach(root => {
      if (states.has(root) || !('IntersectionObserver' in window)) return;

      const entered = new Set();
      const animations = new Map();
      let selected = false;

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const target = entry.target;

          if (!entry.isIntersecting) {
            entered.delete(target);

            const previous = animations.get(target);
            if (previous) {
              previous.cancel();
              animations.delete(target);
            }

            return;
          }

          if (entered.has(target)) return;
          entered.add(target);

          if (reduced.matches || selected || !target.animate) return;

          const animation = target.animate(
            [
              { opacity: 0, transform: 'translateY(10px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ],
            {
              duration: 3000,
              easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'backwards'
            }
          );

          animations.set(target, animation);

          const release = () => {
            if (animations.get(target) === animation) {
              animations.delete(target);
            }
          };

          animation.onfinish = release;
          animation.oncancel = release;
        });
      }, {
        threshold: 0,
        rootMargin: '0px 0px -8% 0px'
      });

      root.querySelectorAll('.av-category-section__copy').forEach(copy => {
        observer.observe(copy);
      });

      const focus = event => {
        const card = event.target.closest('.av-category-section__card');
        const copy = card && card.querySelector('.av-category-section__copy');
        const animation = copy && animations.get(copy);

        if (animation) animation.finish();
      };

      root.addEventListener('focusin', focus);

      states.set(root, {
        observer,
        animations,
        focus,
        select: () => { selected = true; }
      });
    });
  };

  initialize(document);

  document.addEventListener('shopify:section:load', event => {
    initialize(event.target);
  });

  const select = event => {
    const scope = event.target.closest('[data-av-category-animation]') || event.target;

    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) {
        state.select();
        state.animations.forEach(animation => animation.finish());
      }
    });
  };

  document.addEventListener('shopify:section:select', select);
  document.addEventListener('shopify:block:select', select);

  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, root) => {
      if (event.target.contains(root)) {
        state.observer.disconnect();
        state.animations.forEach(animation => animation.cancel());
        root.removeEventListener('focusin', state.focus);
        states.delete(root);
      }
    });
  });

  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      states.forEach(state => {
        state.animations.forEach(animation => animation.finish());
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avirell-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.avirellEditorialRevealV3) return;
  window.avirellEditorialRevealV3 = true;
  const states = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = scope => {
    const roots = [...scope.querySelectorAll('[data-av-editorial-reveal-root]')];
    if (scope.matches && scope.matches('[data-av-editorial-reveal-root]')) roots.unshift(scope);
    roots.forEach(root => {
      if (states.has(root) || !('IntersectionObserver' in window)) return;
      const animations = new Map();
      const entered = new Set();
      let selected = false;
      const observer = new IntersectionObserver(entries => {
        let stagger = 0;
        entries.forEach(entry => {
          const target = entry.target;
          if (!entry.isIntersecting) {
            entered.delete(target);
            const previous = animations.get(target);
            if (previous) { previous.cancel(); animations.delete(target); }
            return;
          }
          if (entered.has(target)) return;
          entered.add(target);
          if (reduced.matches || selected || !target.animate) return;
          const animation = target.animate([
            { opacity: 0, transform: 'translateY(10px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], {
            duration: 2000,
            delay: Math.min(stagger++ * 90, 180),
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'backwards'
          });
          animations.set(target, animation);
          const release = () => {
            if (animations.get(target) === animation) animations.delete(target);
          };
          animation.onfinish = release;
          animation.oncancel = release;
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll(root.dataset.avScrollSelector).forEach(target => observer.observe(target));
      states.set(root, { observer, animations, select: () => { selected = true; } });
    });
  };
  const finish = scope => {
    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) {
        state.animations.forEach(animation => animation.finish());
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  const select = event => {
    const scope = event.target.closest('[data-av-editorial-reveal-root]') || event.target;
    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) state.select();
    });
    finish(scope);
  };
  document.addEventListener('shopify:section:select', select);
  document.addEventListener('shopify:block:select', select);
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, root) => {
      if (event.target.contains(root)) {
        state.observer.disconnect();
        state.animations.forEach(animation => animation.cancel());
        states.delete(root);
      }
    });
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) finish(document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avirell-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.avirellRevealInstalled) return;
  window.avirellRevealInstalled = true;
  const states = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = (scope) => {
    const roots = [...scope.querySelectorAll('[data-av-reveal-root]')];
    if (scope.matches && scope.matches('[data-av-reveal-root]')) roots.unshift(scope);
    roots.forEach(root => {
      if (states.has(root) || !('IntersectionObserver' in window)) return;
      const targets = [...root.querySelectorAll(root.dataset.avRevealSelector)];
      const animations = new Set();
      const observer = new IntersectionObserver(entries => {
        const visible = entries.filter(entry => entry.isIntersecting);
        visible.forEach((entry, index) => {
          observer.unobserve(entry.target);
          if (reduced.matches || !entry.target.animate) return;
          const animation = entry.target.animate([
            { opacity: 0, transform: 'translateY(14px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], {
            duration: 2500,
            delay: Math.min(index * 70, 210),
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'backwards'
          });
          animations.add(animation);
          animation.onfinish = () => animations.delete(animation);
          animation.oncancel = () => animations.delete(animation);
        });
      }, { threshold: 0.08 });
      targets.forEach(target => observer.observe(target));
      states.set(root, { observer, animations });
    });
  };
  const finish = scope => {
    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) {
        state.animations.forEach(animation => animation.finish());
        root.querySelectorAll(root.dataset.avRevealSelector).forEach(target => state.observer.unobserve(target));
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:select', event => finish(event.target));
  document.addEventListener('shopify:block:select', event => finish(event.target.closest('[data-av-reveal-root]') || event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, root) => {
      if (event.target.contains(root)) {
        state.observer.disconnect();
        state.animations.forEach(animation => animation.cancel());
        states.delete(root);
      }
    });
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) finish(document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avirell-lifestyle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBanners = (root) => {
      const banners = [];

      if (root.matches && root.matches('.av-lifestyle')) {
        banners.push(root);
      }

      root.querySelectorAll('.av-lifestyle').forEach((banner) => {
        banners.push(banner);
      });

      banners.forEach((banner) => {
        if (banner.dataset.stickyInitialized === 'true') return;

        const copy = banner.querySelector('.av-lifestyle__copy');
        if (!copy) return;

        banner.dataset.stickyInitialized = 'true';

        const updateHeight = () => {
          banner.style.setProperty(
            '--av-copy-height',
            `${Math.ceil(copy.getBoundingClientRect().height)}px`
          );
        };

        updateHeight();

        const observer = new ResizeObserver(updateHeight);
        observer.observe(copy);
        banner.avLifestyleObserver = observer;
      });
    };

    initializeBanners(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeBanners(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.av-lifestyle').forEach((banner) => {
        if (banner.avLifestyleObserver) {
          banner.avLifestyleObserver.disconnect();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avirell-read-more"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.avirellBrandRevealV3) return;
  window.avirellBrandRevealV3 = true;
  const states = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = scope => {
    const roots = [...scope.querySelectorAll('[data-av-brand-reveal-root]')];
    if (scope.matches && scope.matches('[data-av-brand-reveal-root]')) roots.unshift(scope);
    roots.forEach(root => {
      if (states.has(root) || !('IntersectionObserver' in window)) return;
      const animations = new Map();
      const entered = new Set();
      let selected = false;
      const observer = new IntersectionObserver(entries => {
        let stagger = 0;
        entries.forEach(entry => {
          const target = entry.target;
          if (!entry.isIntersecting) {
            entered.delete(target);
            const previous = animations.get(target);
            if (previous) { previous.cancel(); animations.delete(target); }
            return;
          }
          if (entered.has(target)) return;
          entered.add(target);
          if (reduced.matches || selected || !target.animate) return;
          const animation = target.animate([
            { opacity: 0, transform: 'translateY(10px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], {
            duration: 3000,
            delay: Math.min(stagger++ * 90, 180),
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'backwards'
          });
          animations.set(target, animation);
          const release = () => {
            if (animations.get(target) === animation) animations.delete(target);
          };
          animation.onfinish = release;
          animation.oncancel = release;
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll(root.dataset.avScrollSelector).forEach(target => observer.observe(target));
      states.set(root, { observer, animations, select: () => { selected = true; } });
    });
  };
  const finish = scope => {
    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) {
        state.animations.forEach(animation => animation.finish());
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  const select = event => {
    const scope = event.target.closest('[data-av-brand-reveal-root]') || event.target;
    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) state.select();
    });
    finish(scope);
  };
  document.addEventListener('shopify:section:select', select);
  document.addEventListener('shopify:block:select', select);
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, root) => {
      if (event.target.contains(root)) {
        state.observer.disconnect();
        state.animations.forEach(animation => animation.cancel());
        states.delete(root);
      }
    });
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) finish(document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avirell-style-edit"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.avirellVideoRevealV3) return;
  window.avirellVideoRevealV3 = true;
  const states = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = scope => {
    const roots = [...scope.querySelectorAll('[data-av-video-reveal-root]')];
    if (scope.matches && scope.matches('[data-av-video-reveal-root]')) roots.unshift(scope);
    roots.forEach(root => {
      if (states.has(root) || !('IntersectionObserver' in window)) return;
      const animations = new Map();
      const entered = new Set();
      let selected = false;
      const observer = new IntersectionObserver(entries => {
        let stagger = 0;
        entries.sort((a, b) => {
          if (a.target === b.target) return 0;
          return a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        }).forEach(entry => {
          const target = entry.target;
          if (!entry.isIntersecting) {
            entered.delete(target);
            const previous = animations.get(target);
            if (previous) { previous.cancel(); animations.delete(target); }
            return;
          }
          if (entered.has(target)) return;
          entered.add(target);
          if (reduced.matches || selected || !target.animate) return;
          const animation = target.animate([
            { opacity: 0, transform: 'translateX(-14px)' },
            { opacity: 1, transform: 'translateX(0)' }
          ], {
            duration: 500,
            delay: stagger++ * 500,
            easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
            fill: 'backwards'
          });
          animations.set(target, animation);
          const release = () => {
            if (animations.get(target) === animation) animations.delete(target);
          };
          animation.onfinish = release;
          animation.oncancel = release;
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      root.querySelectorAll(root.dataset.avScrollSelector).forEach(target => observer.observe(target));
      states.set(root, { observer, animations, select: () => { selected = true; } });
    });
  };
  const finish = scope => {
    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) {
        state.animations.forEach(animation => animation.finish());
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  const select = event => {
    const scope = event.target.closest('[data-av-video-reveal-root]') || event.target;
    states.forEach((state, root) => {
      if (scope === root || scope.contains(root)) state.select();
    });
    finish(scope);
  };
  document.addEventListener('shopify:section:select', select);
  document.addEventListener('shopify:block:select', select);
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, root) => {
      if (event.target.contains(root)) {
        state.observer.disconnect();
        state.animations.forEach(animation => animation.cancel());
        states.delete(root);
      }
    });
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) finish(document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  if (window.avirellFooterSmoothMenusInstalled) return;
  window.avirellFooterSmoothMenusInstalled = true;
  const states = new Map();
  const initialize = scope => {
    const footers = [...scope.querySelectorAll('footer[id^="AvFooter-"]')];
    if (scope.matches && scope.matches('footer[id^="AvFooter-"]')) footers.unshift(scope);
    footers.forEach(footer => {
      if (states.has(footer)) return;
      const menus = [...footer.querySelectorAll('[data-av-footer-menu]')];
      const mobile = window.matchMedia('(max-width: 749px)');
      const running = new Map();
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const reset = () => {
        running.forEach(state => state.animation.cancel());
        running.clear();
        menus.forEach(menu => {
          menu.style.height = '';
          menu.style.overflow = '';
        });
      };
      const update = () => {
        reset();
        menus.forEach(menu => { menu.open = !mobile.matches; });
      };
      const click = event => {
        const summary = event.target.closest('.avf-menu__summary');
        if (!summary) return;
        if (!mobile.matches) { event.preventDefault(); return; }
        const menu = summary.closest('[data-av-footer-menu]');
        if (!menu || reduced.matches || !menu.animate) return;
        event.preventDefault();
        const previous = running.get(menu);
        const opening = previous ? !previous.opening : !menu.open;
        const startHeight = menu.getBoundingClientRect().height;
        if (previous) {
          running.delete(menu);
          previous.animation.cancel();
        }
        menu.style.height = '';
        menu.style.overflow = 'hidden';
        menu.open = true;
        const expandedHeight = menu.getBoundingClientRect().height;
        const collapsedHeight = summary.getBoundingClientRect().height;
        const animation = menu.animate([
          { height: startHeight + 'px' },
          { height: (opening ? expandedHeight : collapsedHeight) + 'px' }
        ], {
          duration: 380,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
        });
        const state = { animation, opening };
        running.set(menu, state);
        animation.onfinish = () => {
          if (running.get(menu) !== state) return;
          running.delete(menu);
          menu.open = opening;
          menu.style.height = '';
          menu.style.overflow = '';
        };
      };
      update();
      footer.addEventListener('click', click);
      mobile.addEventListener('change', update);
      states.set(footer, { mobile, update, click, reset });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const menu = event.target.querySelector('[data-av-footer-menu]');
    if (menu) menu.open = true;
  });
  document.addEventListener('shopify:section:unload', event => {
    states.forEach((state, footer) => {
      if (event.target.contains(footer)) {
        state.reset();
        state.mobile.removeEventListener('change', state.update);
        footer.removeEventListener('click', state.click);
        states.delete(footer);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('avirell-gallery-indicators')) {
  customElements.define('avirell-gallery-indicators', class extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.product__media-wrapper');
      if (!this.wrapper) return;
      this.abort = new AbortController();
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.click = event => {
        const button = event.target.closest('button[data-index]');
        if (!button || !this.rail) return;
        const slide = this.slides[Number(button.dataset.index)];
        if (!slide) return;
        const left = this.rail.scrollLeft + slide.getBoundingClientRect().left - this.rail.getBoundingClientRect().left;
        if(this.glide) cancelAnimationFrame(this.glide);
        if(this.reduced.matches){this.rail.scrollTo({left,behavior:'instant'});return;}
        this.rail.style.scrollSnapType='none';
        const start=this.rail.scrollLeft;
        const started=performance.now();
        const step=now=>{
          const progress=Math.min(1,(now-started)/550);
          const eased=1-Math.pow(1-progress,3);
          this.rail.scrollTo({left:start+(left-start)*eased,behavior:'instant'});
          if(progress<1)this.glide=requestAnimationFrame(step);
          else {this.glide=0;this.rail.style.scrollSnapType='';}
        };
        this.glide=requestAnimationFrame(step);
      };
      this.addEventListener('click', this.click, {signal:this.abort.signal});
      this.resize = new ResizeObserver(() => { this.measure(); this.refresh(); });
      this.resize.observe(this.wrapper);
      this.mutation = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.bind();
      });
      this.mutation.observe(this.wrapper, {childList:true,subtree:true,attributes:true,attributeFilter:['class','hidden']});
      window.addEventListener('resize', () => this.measure(), {signal:this.abort.signal,passive:true});
      this.wrapper.addEventListener('dragstart', event => {
        if(window.matchMedia('(max-width:749px)').matches) event.preventDefault();
      }, {signal:this.abort.signal,capture:true});
      this.wrapper.addEventListener('touchstart', () => {
        if(this.glide){cancelAnimationFrame(this.glide);this.glide=0;this.rail.style.scrollSnapType="";}
      }, {signal:this.abort.signal,passive:true});
      this.bind();
      this.measure();
    }
    bind() {
      const rail = this.wrapper.querySelector('.product__media-list');
      if (!rail) return;
      if (this.rail !== rail) {
        if (this.rail && this.scroll) this.rail.removeEventListener('scroll',this.scroll);
        this.rail = rail;
        this.scroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {this.frame=0;this.refresh();});
        };
        rail.addEventListener('scroll',this.scroll,{passive:true});
      }
      const slides = [...rail.querySelectorAll('.product__media-item')].filter(slide => !slide.hidden && getComputedStyle(slide).display !== 'none');
      const changed = !this.slides || slides.length !== this.slides.length || slides.some((slide,index) => slide !== this.slides[index]);
      this.slides = slides;
      this.hidden = slides.length < 2;
      if (changed) {
        this.replaceChildren(...slides.map((slide,index) => {
          const button = document.createElement('button');
          button.type='button';button.dataset.index=String(index);
          button.setAttribute('aria-label','Show image '+(index+1)+' of '+slides.length);
          if(slide.id) button.setAttribute('aria-controls',slide.id);
          return button;
        }));
      }
      this.refresh();
    }
    measure() {
      if (!window.matchMedia('(max-width:749px)').matches) return;
      const top = Math.max(0,this.wrapper.getBoundingClientRect().top + window.scrollY);
      this.wrapper.style.setProperty('--av-gallery-top',Math.round(top)+'px');
    }
    refresh() {
      if (!this.rail || !this.slides || !this.slides.length) return;
      const left = this.rail.getBoundingClientRect().left;
      let current=0,best=Infinity;
      this.slides.forEach((slide,index) => {
        const distance=Math.abs(slide.getBoundingClientRect().left-left);
        if(distance<best){best=distance;current=index;}
      });
      [...this.children].forEach((button,index) => {
        const value=index===current?'true':'false';
        if(button.getAttribute('aria-current')!==value) button.setAttribute('aria-current',value);
      });
    }
    disconnectedCallback() {
      this.abort?.abort();this.resize?.disconnect();this.mutation?.disconnect();
      if(this.rail && this.scroll) this.rail.removeEventListener('scroll',this.scroll);
      if(this.frame) cancelAnimationFrame(this.frame);
      if(this.glide) cancelAnimationFrame(this.glide);
    }
  });
}

(() => {
  if(window.avirellProductInfoRevealInstalled)return;
  window.avirellProductInfoRevealInstalled=true;
  const states=new Map();
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize=scope=>{
    const roots=[...scope.querySelectorAll('product-info[id^="MainProduct-"]')];
    if(scope.matches && scope.matches('product-info[id^="MainProduct-"]'))roots.unshift(scope);
    roots.forEach(root=>{
      if(states.has(root)||!('IntersectionObserver' in window))return;
      const entered=new Set(),animations=new Map(),observed=new Set();
      const observer=new IntersectionObserver(entries=>{
        let order=0;
        entries.forEach(entry=>{
          const target=entry.target;
          if(!entry.isIntersecting){
            entered.delete(target);
            const animation=animations.get(target);
            if(animation){animation.cancel();animations.delete(target);}
            return;
          }
          if(entered.has(target))return;
          entered.add(target);
          if(reduced.matches||!target.animate)return;
          const animation=target.animate([
            {opacity:0,transform:'translateY(8px)'},
            {opacity:1,transform:'translateY(0)'}
          ],{duration:1500,delay:Math.min(order++*60,180),easing:'cubic-bezier(0.22,1,0.36,1)',fill:'backwards'});
          animations.set(target,animation);
          const release=()=>{if(animations.get(target)===animation)animations.delete(target);};
          animation.onfinish=release;animation.oncancel=release;
        });
      },{threshold:0,rootMargin:'0px 0px -5% 0px'});
      const bind=()=>{
        [...observed].forEach(target=>{
          if(!root.contains(target)){observer.unobserve(target);observed.delete(target);entered.delete(target);animations.get(target)?.cancel();animations.delete(target);}
        });
        root.querySelectorAll('.product__info-container > :not(script):not(style):not(template)').forEach(target=>{
          if(observed.has(target))return;
          observed.add(target);observer.observe(target);
        });
      };
      bind();
      const mutation=new MutationObserver(bind);
      mutation.observe(root,{childList:true,subtree:true});
      const focus=event=>{
        animations.forEach((animation,target)=>{if(target.contains(event.target))animation.finish();});
      };
      root.addEventListener('focusin',focus);
      states.set(root,{observer,mutation,animations,focus});
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    states.forEach((state,root)=>{
      if(event.target.contains(root)){
        state.observer.disconnect();state.mutation.disconnect();
        state.animations.forEach(animation=>animation.cancel());
        root.removeEventListener('focusin',state.focus);states.delete(root);
      }
    });
  });
  reduced.addEventListener('change',()=>{
    if(reduced.matches)states.forEach(state=>state.animations.forEach(animation=>animation.finish()));
  });
})();


(() => {
 if(window.avirellGiftRevealInstalled)return;
 window.avirellGiftRevealInstalled=true;
 const states=new Map(),reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const init=scope=>{
  const gifts=[...scope.querySelectorAll('.av-gift')];
  if(scope.matches?.('.av-gift'))gifts.unshift(scope);
  gifts.forEach(gift=>{
   if(states.has(gift)||!('IntersectionObserver' in window))return;
   const animations=new Map(),entered=new Set();
   const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    const target=entry.target;
    if(!entry.isIntersecting){entered.delete(target);animations.get(target)?.cancel();animations.delete(target);return;}
    if(entered.has(target))return;
    entered.add(target);
    if(reduced.matches||!target.animate)return;
    const photo=target.matches('.av-gift__media img');
    const frames=photo?[{transform:'scale(1.2)'},{transform:'scale(1)'}]:[{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}];
    const animation=target.animate(frames,{duration:6000,easing:'cubic-bezier(0.22,1,0.36,1)',fill:'backwards'});
    animations.set(target,animation);
    const release=()=>{if(animations.get(target)===animation)animations.delete(target);};
    animation.onfinish=release;animation.oncancel=release;
   }),{threshold:0,rootMargin:'0px 0px -5% 0px'});
   gift.querySelectorAll('.av-gift__media img,.av-gift__copy h2,.av-gift__copy p,.av-gift__copy a').forEach(target=>observer.observe(target));
   const focus=event=>animations.forEach((animation,target)=>{if(target.contains(event.target))animation.finish();});
   gift.addEventListener('focusin',focus);
   states.set(gift,{observer,animations,focus});
  });
 };
 init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>states.forEach((state,gift)=>{
  if(event.target.contains(gift)){state.observer.disconnect();state.animations.forEach(animation=>animation.cancel());gift.removeEventListener('focusin',state.focus);states.delete(gift);}
 }));
 reduced.addEventListener('change',()=>{if(reduced.matches)states.forEach(state=>state.animations.forEach(animation=>animation.finish()));});
})();


  } catch(e) { console.error(e); }
})();
})();
